export default "__VITE_ASSET__DwvOFmcm__"